/**
 * ResponsiveSwitch — рендерит РАЗНЫЕ поддеревья на телефоне и десктопе.
 *
 * Основа парадигмы «отдельные десктоп-лейауты» (2026-07-25): один роут,
 * два лейаута. Формализует ad-hoc паттерн `useIsMobile() ? <M/> : <D/>`
 * (напр. AnalyticsEntry) в переиспользуемый примитив, чтобы switch был
 * единообразным по всему app.
 *
 *   <ResponsiveSwitch mobile={<TodayMobile />} desktop={<TodayDesktop />} />
 *
 * Только смонтированное поддерево исполняет свои хуки — второй JSX-элемент
 * создаётся, но не рендерится (React монтирует лишь возвращённое). Для
 * КОД-СПЛИТА (не грузить desktop-бандл на телефоне) используй `useIsDesktop`
 * напрямую с `lazy()` вместо этого компонента.
 */
import type { ReactNode } from "react";
import { useIsMobile } from "../hooks/useIsMobile";

export function ResponsiveSwitch({
  mobile,
  desktop,
  breakpoint = 768,
}: {
  mobile: ReactNode;
  desktop: ReactNode;
  breakpoint?: number;
}) {
  return <>{useIsMobile(breakpoint) ? mobile : desktop}</>;
}
